import React, { Component } from "react";
import calcularPx from "../calcularPx.js";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../res/iconos/logo.svg";
import { ReactComponent as IcoMenu } from "../../../res/iconos/menu.svg";
import Menu from "./menu.jsx";
import { CSSTransition } from "react-transition-group";
import { useParams, useNavigate, useLocation } from "react-router-dom";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class NavBar extends Component {
  state = { mostrarMenu: false, nivelLogin: this.props.nivelLogin, region: null, icono: "int" };

  componentDidMount() {
    const regiones = ['ar','mx','bo','cl'];
      const primero = this.props.params['*'].split("/")[0];
      
      let icono = regiones.find((r) => r == primero)??'int';
      let region = icono == 'int'?'ar':icono;

      this.setState({ region, icono });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin || prevProps.params['*'] != this.props.params['*']) {
      const regiones = ['ar','mx','bo','cl'];
      const primero = this.props.params['*'].split("/")[0];
      let region;
      let icono = regiones.find((r) => r == primero)??'int';
      if (icono != 'int') {
        region = icono;
      } else {
        region = 'ar';
      }
      this.setState({ nivelLogin: this.props.nivelLogin, region, icono });
    }
  }

  setRegion(region) {
    let siguiente;
    if (region != this.state.region) {
      if (region == 'ar' && this.state.region != 'int') {
        siguiente = "/home";
      } else if (region != 'ar') {
        siguiente = "/" + region + "/productos";
      }
    }
    this.setState({region: region, icono: region}, () => {if (siguiente) this.props.navigate(siguiente)})
  }

  ocultarMenu() {
    this.setState({ mostrarMenu: false });
  }

  render() {
    const mobile = window.innerWidth < 1100;
    const {region, icono} = this.state; 
    return (
      <div
        style={{
          top: 0,
          position: "sticky",
          background: "#5B5D61",
          height: calcularPx(102),
          zIndex: 100,
        }}
      >
        <div style={mobile?{height: "100%"}:{/*paddingLeft: "10%", paddingRight: "10%",*/ height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "14%"}}>
          <Link
            to={(region != 'ar')?`/${region}/productos`:"/home"}
            onClick={this.ocultarMenu}
            style={{ position: "relative", left: "5%" }}
          >
            <img src={require("../../../res/iconos/logoNuevo.png")} style={{height: mobile?"100%":calcularPx(102), marginTop: -5}} />
          </Link>
          {mobile && (
            <React.Fragment>
              <button
                onClick={() => {
                  this.setState({ mostrarMenu: !this.state.mostrarMenu });
                }}
                style={{
                  position: "absolute",
                  top: calcularPx(34),
                  right: "calc(3.44% + " + calcularPx(34.79) + ")",
                  background: "transparent",
                  border: "none",
                }}
              >
                <IcoMenu
                  style={{ position: "absolute" }}
                  width={calcularPx(34.79)}
                  height={calcularPx(26.88)}
                />
              </button>
              <CSSTransition
                in={this.state.mostrarMenu}
                timeout={100}
                classNames="opacidad"
                unmountOnExit
              >
                <Menu
                  style={{ position: "absolute" }}
                  mobile={mobile}
                  ocultar={this.ocultarMenu.bind(this)}
                  nivelLogin={this.state.nivelLogin}
                  region={region}
                  setRegion={this.setRegion.bind(this)}
                  icono={icono}
                  botones={this.props.botones}
                />
              </CSSTransition>
            </React.Fragment>
          )}
          {!mobile && (
            <Menu
              style={{ position: "absolute" }}
              mobile={mobile}
              ocultar={this.ocultarMenu.bind(this)}
              nivelLogin={this.state.nivelLogin}
              region={region}
              setRegion={this.setRegion.bind(this)}
              icono={icono}
              botones={this.props.botones}
            />
          )}          
        </div>
        
      </div>
    );
  }
}

export default withRouterAndNavigate(NavBar);
